import { memo } from "react";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// -----------------------------------------------------------------------------

const OktaConnectSetupPageError = memo(function OktaConnectSetupPageError({
  show,
  onTryAgain,
  children,
}: OktaConnectSetupPageErrorProps) {
  return show ? (
    <Alert severity="error">
      {children ?? "There was an error"}
      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="error"
          onClick={onTryAgain as React.MouseEventHandler<HTMLButtonElement>}
        >
          Try Again
        </Button>
      </Box>
    </Alert>
  ) : null;
});

export default OktaConnectSetupPageError;

// -----------------------------------------------------------------------------

interface OktaConnectSetupPageErrorProps {
  show: boolean;
  onTryAgain: Function;
  children: React.ReactNode;
}
